import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CalendarEvent extends Vue
{
    @Prop()
    private value: any;

    /**
     * Handles left click
     *
     * @param event
     */

    private onLeftClick(event: Event)
    {
        this.$emit('left-click', event);
    }
}